import React from 'react';
import css from './interactive_text.module.scss';

interface InteractiveTextProps {
  text: string;
  handleClick: () => void;
}

export default function InteractiveText({
  text,
  handleClick
}: InteractiveTextProps) {
  return (
    <p className={css.text} onClick={handleClick}>
      {text}
    </p>
  );
}
